document.querySelectorAll('.marquee').forEach(function(marquee) {
    let marqueeLerpScroll = 0;
	let marqueeOffsetTop = marquee.offsetTop;
	let marqueeOffsetHeight = marquee.offsetHeight;

	function updateMarqueeVars() {
		marqueeOffsetTop = marquee.offsetTop;
		marqueeOffsetHeight = marquee.offsetHeight;
	}

    window.addEventListener('load', updateMarqueeVars);
    window.addEventListener('resize', updateMarqueeVars);

	function marqueeIsInViewport() {
		let inview = document.documentElement.scrollTop + document.documentElement.clientHeight >= marqueeOffsetTop && document.documentElement.scrollTop < marqueeOffsetTop + marqueeOffsetHeight;

		if( inview ) {
			let percent = 100 - ( ((marqueeOffsetTop + marqueeOffsetHeight) - document.documentElement.scrollTop - 85) / (document.documentElement.clientHeight + marqueeOffsetHeight) * 100 );

			marqueeLerpScroll += (percent - marqueeLerpScroll) * 0.1;
			marquee.querySelector(":scope > div:first-child").style.transform = `translateX(${marqueeLerpScroll}%)`;
			marquee.querySelector(":scope > div:last-child").style.transform = `translateX(-${marqueeLerpScroll}%)`;
		}

		window.requestAnimationFrame(marqueeIsInViewport);
	}
	marqueeIsInViewport();
});
